import { SredCategory, SredEmployeeType, WageType } from '@neo.tax/shared';

export const SRED_CATEGORY_LABELS: Record<SredCategory, string> = {
  [SredCategory.Employee]: 'Employee',
  [SredCategory.ContractorArmsLength]: "Contractor (Arm's Length)",
  [SredCategory.ContractorNonArmsLength]: "Contractor (Non-Arm's Length)",
  [SredCategory.MaterialsConsumed]: 'Materials Consumed',
  [SredCategory.MaterialsTransformed]: 'Materials Transformed',
  [SredCategory.Overhead]: 'Overhead',
  [SredCategory.NonSred]: 'Not SR&ED',
  [SredCategory.Unknown]: 'Unknown',
};

export const SRED_EMPLOYEE_TYPE_LABELS: Record<SredEmployeeType, string> = {
  [SredEmployeeType.Direct]: 'Direct',
  [SredEmployeeType.Supervisor]: 'Supervisor',
  [SredEmployeeType.Support]: 'Support',
};

export const WAGE_TYPE_LABELS: Record<WageType, string> = {
  [WageType.W2]: 'T4/T4A',
  [WageType.Contractor]: 'Contractor',
};
